import PropTypes from "prop-types";
import {Button, Image, Typography} from "antd";
import iconMap from "../assets/images/iconMap.png";
import iconMic from "../assets/images/iconMic.png";
import {moneyFormat} from "../untils/constanst";

const ROOM_TYPE_LABELS = {
    small: "Small",
    medium: "Medium",
    large: "Large",
};

const DURATION_LABELS = {
    exact: "Khớp giờ",
    shorter: "Ngắn hơn",
    longer: "Dài hơn",
};

const getDurationBadge = (slot = {}) => {
    const label = DURATION_LABELS[slot.duration_type] || "Phù hợp";
    const variance = Math.abs(Number(slot.variance_minutes || 0));

    if (slot.duration_type === "shorter" || slot.duration_type === "longer") {
        return variance > 0 ? `${label} ${variance} phút` : label;
    }

    return label;
};

const getPaymentPrice = (slot = {}) => {
    const price = Number(slot.priceOrder || 0);
    const discountedPrice = Number(slot.priceOrderDiscount || 0);

    if (discountedPrice > 0) {
        return discountedPrice;
    }

    return price;
};

const hasDiscount = (slot = {}) => {
    const price = Number(slot.priceOrder || 0);
    const discountedPrice = Number(slot.priceOrderDiscount || 0);
    return price > 0 && discountedPrice > 0 && discountedPrice !== price;
};

const RoomSuggestionCard = ({
    item,
    itemKey,
    loadingKey,
    loadingOrder,
    onBook,
    groupLabel,
    accentColor,
    compact,
}) => {
    const paymentPrice = getPaymentPrice(item);
    const roomTypeLabel = ROOM_TYPE_LABELS[item?.room_type] || item?.room_type || "Box";
    const buttonColor = item?.isExactDuration ? "#237804" : accentColor;
    const mapUrl = item?.google_map_direct_link || item?.google_map;

    return (
        <div
            className={
                "room-suggestion-card" +
                (item?.isExactDuration ? " is-exact" : "") +
                (!item?.isBookable ? " is-disabled" : "")
            }
        >
            <div className="room-suggestion-card__top">
                <div>
                    <Typography.Title
                        className="room-suggestion-card__title"
                        level={compact ? 5 : 4}
                    >
                        {item?.room_name || item?.name}
                    </Typography.Title>
                    {item?.branch_name && item?.branch_name !== item?.room_name && (
                        <Typography.Text className="room-suggestion-card__branch">
                            {item.branch_name}
                        </Typography.Text>
                    )}
                </div>
                <div className="room-suggestion-card__badges">
                    <span
                        className="room-suggestion-card__badge"
                        style={{borderColor: accentColor, color: accentColor}}
                    >
                        {groupLabel}
                    </span>
                    <span
                        className={
                            "room-suggestion-card__badge" +
                            (item?.isExactDuration ? " is-best" : "")
                        }
                    >
                        {getDurationBadge(item)}
                    </span>
                </div>
            </div>

            {item?.address && mapUrl && (
                <a
                    href={mapUrl}
                    target="_blank"
                    rel="noreferrer"
                    className="room-suggestion-card__line"
                >
                    <Image preview={false} src={iconMap}/>
                    <span>{item.address}</span>
                </a>
            )}
            {item?.address && !mapUrl && (
                <div className="room-suggestion-card__line">
                    <Image preview={false} src={iconMap}/>
                    <span>{item.address}</span>
                </div>
            )}

            <div className="room-suggestion-card__line">
                <Image preview={false} src={iconMic}/>
                <span>
                    {roomTypeLabel} Box
                    {item?.capacity ? `, từ ${item.capacity} người` : ""}
                </span>
            </div>

            <div className="room-suggestion-card__time">
                <div>
                    <span className="room-suggestion-card__label">Khung giờ</span>
                    <strong>
                        {item?.start_time_formatted} - {item?.end_time_formatted}
                    </strong>
                </div>
                <span>{item?.duration_description || `${item?.duration_minutes} phút`}</span>
            </div>

            <div className="room-suggestion-card__footer">
                <div>
                    <p className="text-order-price">Tổng tiền thanh toán</p>
                    {paymentPrice > 0 ? (
                        <h5 className="text-order-number color-btn">
                            {hasDiscount(item) && (
                                <span className="origin-price not-same">
                                    {moneyFormat(item.priceOrder)} VND
                                </span>
                            )}
                            <span>{moneyFormat(paymentPrice)} VND</span>
                        </h5>
                    ) : (
                        <h5 className="text-order-number color-btn">Đang cập nhật</h5>
                    )}
                </div>

                <Button
                    disabled={!item?.isBookable}
                    loading={loadingOrder && loadingKey === itemKey}
                    onClick={() => onBook(item, itemKey)}
                    className="room-suggestion-card__button"
                    style={{
                        color: buttonColor,
                        borderColor: buttonColor,
                        backgroundColor: item?.isExactDuration ? "#f6ffed" : "transparent",
                    }}
                >
                    {item?.isBookable ? "Đặt phòng" : "Chưa thể đặt"}
                </Button>
            </div>
        </div>
    );
};

RoomSuggestionCard.propTypes = {
    item: PropTypes.object.isRequired,
    itemKey: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    loadingKey: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    loadingOrder: PropTypes.bool,
    onBook: PropTypes.func.isRequired,
    groupLabel: PropTypes.string.isRequired,
    accentColor: PropTypes.string.isRequired,
    compact: PropTypes.bool,
};

export default RoomSuggestionCard;
